export default __webpack_public_path__ + "static/media/learose3-1920w.fb8e5182.png";